module.exports = __webpack_public_path__ + "static/media/_ME10763.fd04815b.jpg";